module.exports = __webpack_public_path__ + "front/img/kv02.cf4ba0bc.png";